import { Scale } from "../../../utils/Scale"

export class VapPos {

    static roomX = () => Scale.width() * 0.15
    static roomY = () => Scale.height() * 0.33

    static babyButtonX = () => Scale.width() * 0.33
    static babyButtonY = () => Scale.height() * 0.55

    static babyCribX = () => Scale.width() * 0.21
    static babyCribY = () => Scale.height() * 0.52

    static dogX = () => Scale.width() * 0.39
    static dogY = () => Scale.height() * 0.75

    static momVaporX = () => Scale.width() * 0.325
    static momVaporY = () => Scale.height() * 0.5

    static roomVaporX = () => Scale.width() * 0.15
    static roomVaporY = () => Scale.height() * 0.3
    static roomVaporY2 = () => Scale.height() * 0.4

    static roomVapor2X = () => Scale.width() * 0.1
    static roomVapor2Y = () => Scale.height() * 0.3
    static roomVapor2Y2 = () => Scale.height() * 0.55

    static roomVapor3X = () => Scale.width() * 0.27
    static roomVapor3Y = () => Scale.height() * 0.4
    static roomVapor3Y2 = () => Scale.height() * 0.7

    static roomVapor4X = () => Scale.width() * 0.64
    static roomVapor4Y = () => Scale.height() * 0.45
    static roomVapor4Y2 = () => Scale.height() * 0.6

    static vaporPuddleX = () => Scale.width() * 0.42
    static vaporPuddleY = () => Scale.height() * 0.825
}
